<template lang="pug">
  app-modal.modalLegislacao(
    titulo="Consulta à Legislação",
    :width="900",
    @closeModal="closeModal()"
  )
    template(slot="body")
      el-input(
        placeholder="Pesquise o termo desejado",
        v-model="termo",
        @input="getLegislacoesByTermo",
      )
        el-button(
          slot="append",
          icon="el-icon-search",
          @click="getLegislacoesByTermo"
        )
      el-button.btn(
        type="text",
        @click="setContentEmpty()",
      )
        | Limpar
      el-collapse.margin-top(
        v-model='abaAtiva',
        accordion
        v-if="legislacoes.length > 0"
      )
        el-collapse-item(
          v-for="legislacao in legislacoes",
          :key="legislacao.id"
          :title='legislacao.titulo',
          :name='legislacao.id'
        )
          .panel
            p(v-html="legislacao.texto")
          .voltar-topo
            el-button.btn(
              type="text",
              @click="scrollTop",
            )
              | Voltar ao Topo &nbsp
              i.fa.fa-chevron-up
      .msg(v-else)
        p Nenhuma legislação encontrada com este(s) termo(s).
    template(slot="footer")
</template>

<script>
import { mapActions } from 'vuex'
import AppModal from '@/components/AppModal'

export default {
  data () {
    return {
      termo: '',
      abaAtiva: 0,
      legislacoes: null
    }
  },

  components: {
    AppModal
  },

  async created () {
    this.legislacoes = await this.listarLegislacoes()
  },

  methods: {
    ...mapActions({
      listarLegislacoes: 'legislacao/listarLegislacoes',
      getByTexto: 'legislacao/getByTexto'
    }),

    scrollTop () {
      this.abaAtiva = 0
    },

    async getLegislacoesByTermo () {
      var filtroSimples = {
        campoSimples: this.termo
      }
      this.legislacoes = await this.getByTexto(filtroSimples)
      this.abaAtiva = 0
    },

    async setContentEmpty () {
      this.termo = ''
      this.abaAtiva = 0
      this.legislacoes = await this.listarLegislacoes()
    },

    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped>

  .processo {
    margin-top: 0;
    padding-top: 0;
  }

  .row {
    margin-top: 10px;
  }

  .margin-bottom {
    margin-bottom: 1vh;
  }

  .voltar-topo {
    display: flex;
    justify-content: flex-end;

    .btn {
      padding: 0;
    }
  }

  .msg {
    display: flex;
    justify-content: center;
  }

  @media (max-width: 780px) {
    .modalLegislacao {
      width: 395px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalLegislacao.vue